import React, { useEffect, useState } from "react";
import "./Sidebar.css";

const Sidebar = ({ filters }) => {
  const [topStates, setTopStates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch("https://api-sales-insights.haqdarshak.com/state/top-benefits", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(filters || {})
    })
      .then(res => res.json())
      .then(data => {
        setTopStates(data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("Sidebar API Error:", err);
        setLoading(false);
      });
  }, [filters]);

  return (
    <aside className="sidebar">
      <h1 className="sidebar-header">
        Top 10 States by Benefit Value
      </h1>

      {loading && <p className="sidebar-loading">Loading...</p>}

      {!loading && topStates.length === 0 && (
        <p className="sidebar-empty">No data available</p>
      )}

      <ul className="top-states-list">
        {topStates.map((state, index) => (
          <li key={index} className="state-item">
            <div className="state-text">
              <span className="state-name">
                {state.State}
              </span>
              <span className="state-benefits">
                ₹{Number(state.benefitValue || 0).toLocaleString("en-IN")}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;

